import type { PaginatedResults } from '../types/paginated-results'

export const nextPageParamGetter = <T>(currentPage: PaginatedResults<T>) =>
  currentPage.next ? currentPage.current + 1 : undefined
